import React from 'react';

const AddProduct = () => {
    return (
        <div>
            <h2>ADDD HD JFD F </h2>
        </div>
    );
};

export default AddProduct;